<template>
    <BasePanel :alvqa="alvqa" headline="lang_GENERIC_CAPTION_OTHER_IDS">
        <template v-slot:panelContent>
            <v-data-table         
                :headers="headers"
                :items="item"
                hide-default-footer
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
                :items-per-page="itemsPerPage"
                :page.sync="currentPage"
            >
                <!-- alvqas for headers: missing ALVID after sourceName + ' (' + item.sourceAlvId + ')' -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

                <template v-slot:[`item.sourceObject`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.type + '-text-source-alv-id'">
                        {{ $alvPlugin.showNameOfAzEntry(item.sourceObject) }} 
                    </div>
                </template>
                <template v-slot:[`item.otherId`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.type + '-text-other-id'">
                        {{ item.otherId }}
                    </div>
                </template>
                <template v-slot:item.country="{ item }">
                    <BaseTooltip>
                        <!-- the two‑letter code as the trigger -->
                        <template v-slot:text>
                        {{ item.country }}
                        </template>
                        <!-- the full, translated name on hover -->
                        <template v-slot:content>
                        {{ $alvPlugin.getTranslatedCountryName(item.country, true) }}
                        </template>
                    </BaseTooltip>
                </template>
            </v-data-table>
            <v-pagination
                v-if="numberOfPages > 1"
                total-visible="10"
                v-model="currentPage"
                :length="numberOfPages"
                color="pagination"
            ></v-pagination>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
    name: "WorkOtherIdsPanel",
    components: {
        BasePanel,
        BaseTooltip,
    },
    props:{
        workAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: 'publishing-works-list-row-' + this.workAlvId + '-read-only-panel-other-ids',
            currentPage: 1
        }
    },
    computed: {
        item() {
            let item = this.$store.getters.getExpandedWorks.find(element => {              
                return element.alvId === this.workAlvId
            }) 
            
            let otherIds = item.otherIds === null ? [] : item.otherIds
            return otherIds
        },
        headers() {
            return [
                {
                    text: this.$t("lang_GENERIC_CAPTION_SOURCE"), 
                    align: "left", 
                    value: "sourceObject",
                    sortable: false,
                    alvqa: this.alvqa + '-header-source'
                },
                {
                    text: this.$t("lang_PUBLISHING_WORKS_CAPTION_WORK_ID"), 
                    align: "left", 
                    value: "otherId",
                    sortable: false,
                    alvqa: this.alvqa + '-header-other-id'
                },
                {
                    text: this.$t("lang_GENERIC_CAPTION_COUNTRY"), 
                    align: "right", 
                    value: "country",
                    width: "80px",
                    sortable: false,
                    alvqa: this.alvqa + '-header-country'
                }
            ]
        },
        
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
        numberOfPages() { return Math.ceil(this.item.length / this.itemsPerPage) },
    },
    methods: {
    }
    
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
    }
</style>